import React, { useState } from 'react';
import { PageHead } from '../finance/shared';
import CoachSearchTab from './CoachSearchTab';
import CoachCandidatesTab from './CoachCandidatesTab';
import CoachOrgRequestsTab from './CoachOrgRequestsTab';
import CoachOrgOffersTab from './CoachOrgOffersTab';
import CoachStaffTab from './CoachStaffTab';

const TABS = [
  { key: 'search', label: 'البحث عن مدربين' },
  { key: 'candidates', label: 'المرشحون' },
  { key: 'requests', label: 'طلبات التواصل' },
  { key: 'offers', label: 'العروض' },
  { key: 'staff', label: 'الطاقم التدريبي' },
];

export default function CoachRecruitmentPage() {
  const [tab, setTab] = useState('search');

  return (
    <div className="space-y-6" data-testid="coach-recruitment-page">
      <PageHead title="استقطاب المدربين" desc="بحث، استقطاب، ومتابعة تعاقدات الطاقم التدريبي" />

      <div className="flex gap-1 overflow-x-auto rounded-lg border border-slate-200 bg-white p-1">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`coach-recruitment-tab-${t.key}`}
            className={`whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${tab === t.key ? 'bg-[#16233b] text-white' : 'text-slate-600 hover:bg-slate-50'}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'search' && <CoachSearchTab />}
      {tab === 'candidates' && <CoachCandidatesTab />}
      {tab === 'requests' && <CoachOrgRequestsTab />}
      {tab === 'offers' && <CoachOrgOffersTab />}
      {tab === 'staff' && <CoachStaffTab />}
    </div>
  );
}
